module.exports = __webpack_public_path__ + "static/media/partner-yjy@2x.0da0361c.png";